/**
 * mapFocus — pure helper for the traffic map (FEAT-ANALYTICS-001). Picks the
 * cluster of heaviest-traffic points to frame, so the map focuses on where the
 * traffic actually is and a few far-flung outliers don't force a zoomed-out
 * world view where country names are unreadable. No Leaflet import → unit-testable.
 */

/**
 * @param {Array<{v:number}>} points  traffic points (v = users)
 * @param {{coverage?:number}} opts    fraction of total traffic the focus must cover
 * @returns {{ focus: Array, busiest: object|null }}
 *   focus   = the fewest heaviest points that together carry `coverage` of traffic
 *   busiest = the single highest-traffic point (the fallback center)
 */
export function focusCluster(points, { coverage = 0.7 } = {}) {
  if (!Array.isArray(points) || points.length === 0) return { focus: [], busiest: null };
  const sorted = [...points].sort((a, b) => (b.v || 0) - (a.v || 0));
  const total = sorted.reduce((s, p) => s + (p.v || 0), 0) || 1;
  let acc = 0;
  const focus = [];
  for (const p of sorted) {
    focus.push(p);
    acc += (p.v || 0);
    if (acc / total >= coverage) break;
  }
  return { focus, busiest: sorted[0] };
}
